var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsPhone = function SvgLeonInmobiliariaIconsPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-phone_svg__st0{display:none}.leon-inmobiliaria-icons-phone_svg__st1{fill:currentcolor}.leon-inmobiliaria-icons-phone_svg__st1,.leon-inmobiliaria-icons-phone_svg__st2{display:inline}.leon-inmobiliaria-icons-phone_svg__st3{fill:currentcolor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-phone_svg__Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-phone_svg__phone-light",
    className: "leon-inmobiliaria-icons-phone_svg__st3",
    d: "m13.9 13.8 15.8-3.6c2.3-.5 4.7.7 5.6 2.8l7.3 16.9c.9 2 .3 4.3-1.4 5.7l-8.4 6.9a54.6 54.6 0 0 0 24.9 24.9l6.9-8.4c1.4-1.7 3.7-2.2 5.7-1.4l16.9 7.3c2.2.9 3.4 3.3 2.8 5.6l-3.6 15.7c-.5 2.2-2.5 3.8-4.8 3.8-39.5 0-71.5-32-71.5-71.5 0-2.3 1.6-4.2 3.8-4.7zM81.5 85l3.6-15.6-16.8-7.2L59 73.6c-14.7-6.1-26.4-17.8-32.5-32.5l11.4-9.3L30.7 15l-15.6 3.6C15.2 55.3 44.9 85 81.5 85z"
  }))));
};
export default SvgLeonInmobiliariaIconsPhone;